/**
 * Expose a single entry point where both the client and server can use
 */
export const config = {
  analytics: {
    newrelic: {
      ENABLED: process.env.NEW_RELIC_ENABLED,
      LICENSE_KEY: process.env.NEW_RELIC_LICENSE_KEY
    },
    rollbar: {
      CLIENT_SIDE_TOKEN: process.env.ROLLBAR_CLIENT_SIDE_TOKEN,
      SERVER_SIDE_TOKEN: process.env.ROLLBAR_SERVER_SIDE_TOKEN
    },
    cookiebot: { COOKIEBOT_ID: process.env.COOKIEBOT_ID }
  },
  assets: { PUBLIC_PATH: process.env.PUBLIC_PATH },
  cache: { DISABLE_CACHE: process.env.DISABLE_CACHE },
  eventsApi: { URL: process.env.EVENTS_API_URL },
  sso: {
    RECAPTCHA_KEY: process.env.RECAPTCHA_KEY,
    SERVER_HOST: process.env.SSO_SERVER_HOST
  },
  HOMEPAGE_JSON_BUCKET_URL: process.env.HOMEPAGE_JSON_BUCKET_URL,
  HOMEPAGE_JSON_CDN_URL: process.env.HOMEPAGE_JSON_CDN_URL
}
